export default "__VITE_ASSET__MM0LPgOi__"